<div class="spinner-block" *ngIf="isVisible$ | async">
  <div class="spinner-screen">
    <div class="loading-spinner">
      <div class="loading fa fa-spinner fa-spin fa-5x"></div>
    </div>
  </div>
</div>
